import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { usePostHog } from "posthog-js/react";

import { compareImages, CompareImagesRequest } from "@/api";
import { PostHogEvent } from "@/shared/types";
import { useOnboardingStore } from "stores/onboarding.store";
import { useUIStore } from "stores/ui.store";

const useCompareImages = () => {
  const { push } = useRouter();
  const posthog = usePostHog();

  const currentStep = useOnboardingStore((state) => state.currentStep);
  const openToast = useUIStore((state) => state.actions.toast.openToast);
  const { setIsPhotoVerified, setCurrentStep, addPassedStep } = useOnboardingStore((state) => state.actions);

  const isFirstPassingStep = useOnboardingStore((state) => !state.passedSteps.includes(currentStep));

  return useMutation({
    mutationFn: (body: CompareImagesRequest) => {
      return compareImages(body);
    },
    onSuccess: ({ isVerified }) => {
      if (isVerified) {
        if (isFirstPassingStep) {
          posthog?.capture(PostHogEvent.PHOTO_VERIFIED);
        }

        setCurrentStep(currentStep + 1);
        addPassedStep(currentStep);
        openToast({ variant: "success", message: "Your photo has been successfully verified!" });
      } else {
        openToast(
          {
            variant: "error",
            message: "Your photo could not be verified. Please try again with a clear, well-lit image.",
          },
          2000
        );
      }
      setIsPhotoVerified(isVerified);

      push("/auth/onboarding");
    },
    onError: (error) => {
      const e: any = error;
      const customError = e as any;

      openToast({ message: customError.response.data.message, variant: "error" });
      push("/auth/onboarding");
    },
  });
};

export { useCompareImages };
